import React, { Component, PropTypes } from 'react';
import {
  Styles,
  TextField,
  CircularProgress,
  Paper,
  RaisedButton,
  IconButton
} from 'material-ui';
import Spinner from 'components/Material/Spinner';
import CoursioLogo from 'components/CoursioLogo';
import { GooglePlus, FacebookLogo } from 'components/Widgets';
import Message from 'services/Message';
import { FormattedMessage } from 'react-intl';
import Google from 'services/Google';
import Facebook from 'services/Facebook';
import AuthActions from 'actions/Auth';
import * as Colors from 'components/Material/Styles/Colors';
import * as MaterialIcons from 'components/Material/SvgIcons';
import { mixin, RefluxMixin } from 'Util';
import { AuthStore } from 'stores';
import ForgotPasswordForm from 'components/ForgotPasswordForm';

let { Spacing } = Styles;

export default class LoginForm extends mixin(RefluxMixin, Component) {
  state = {
    displayName: localStorage && localStorage.displayName,
    forgotPassword: false
  };

  static propTypes = {
    onLogin: PropTypes.func
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  listenToStores() {
    this.listenToStore(AuthStore);
  }

  resetLogin() {
    this.setState({ displayName: null });
  }

  loginWithGoogle(e) {
    Google.signIn().then(
      res => {
        // this.props.onLogin();
      },
      e => {
        Message.info(e.error);
      }
    );
  }

  loginWithFacebook() {
    Facebook.getLoginUrl();
  }

  submit(e) {
    let email = this.refs.email.getValue(),
      password = this.refs.password.getValue();
    e.preventDefault();

    if (!email || !password) {
      Message.info('Please provide credentials.');
      return;
    }
    AuthActions.login(email, password);
  }

  forgotPassword = email => {
    AuthActions.requestNewPassword(email);
    this.setState({ forgotPassword: false });
  };

  render() {
    if (this.state.forgotPassword) {
      return <ForgotPasswordForm onSubmit={this.forgotPassword} />;
    }

    let button,
      h4Style = {
        padding: Spacing.desktopGutterMini,
        textAlign: 'center',
        fontSize: '.75em',
        color: Colors.Colors.grey[500].material,
        textTransform: 'uppercase'
      };
    if (this.props.loggingIn) {
      button = (
        <div style={{ textAlign: 'center' }}>
          <CircularProgress mode="indeterminate" />
        </div>
      );
    } else {
      button = (
        <RaisedButton
          fullWidth={true}
          label={this.context.getIntlMessage('Login')}
          secondary={true}
          onTouchTap={this.submit.bind(this)}
        />
      );
    }
    let knownUser = this.state.displayName,
      greeting =
        (knownUser && (
          <FormattedMessage
            message={this.context.getIntlMessage('welcomeBack')}
            user={knownUser}
          />
        )) ||
        this.context.getIntlMessage('Login'),
      useOtherLogin = knownUser && (
        <h4
          style={Object.assign({ cursor: 'pointer' }, h4Style)}
          onTouchTap={this.resetLogin.bind(this)}
        >
          {this.context.getIntlMessage('useOtherLogin')}
        </h4>
      ),
      alternativeLogins,
      footer;

    if (!knownUser) {
      alternativeLogins = (
        <div>
          <RaisedButton
            fullWidth={true}
            backgroundColor={'#DC4A38'}
            secondary={true}
            onTouchTap={this.loginWithGoogle.bind(this)}
            label={
              <span>
                <GooglePlus
                  style={{ verticalAlign: 'middle' }}
                  width="32px"
                  height="32px"
                />
                {this.context.getIntlMessage('loginWithGoogle')}
              </span>
            }
          />
          <RaisedButton
            onTouchTap={::this.loginWithFacebook}
            style={{ marginTop: Spacing.desktopGutterMini }}
            fullWidth={true}
            backgroundColor={'#3B5998'}
            secondary={true}
            label={
              <span>
                <FacebookLogo
                  background={'transparent'}
                  style={{ verticalAlign: 'middle' }}
                  width="32px"
                  height="32px"
                />
                {this.context.getIntlMessage('loginWithFacebook')}
              </span>
            }
          />
        </div>
      );
      footer = (
        <h4
          style={{
            textAlign: 'center',
            padding: '8px',
            lineHeight: '32px',
            color: '#09BEC3',
            fontSize: '24px'
          }}
        >
          <CoursioLogo
            style={{ verticalAlign: 'middle', lineHeight: '32px' }}
            initialFill="#09BEC3"
            size={32}
            circleRadius={3}
          />
          <span style={{ verticalAlign: 'middle', marginLeft: '8px' }}>
            coursio
          </span>
        </h4>
      );
    }

    return (
      <div>
        <form onSubmit={this.submit.bind(this)}>
          <div
            style={{
              paddingTop: Spacing.desktopGutterMore,
              paddingBottom: Spacing.desktopGutterMore,
              textAlign: 'center'
            }}
          >
            <CoursioLogo initialFill="#09BEC3" />
          </div>
          <div style={{ textAlign: 'center' }}>
            <h1
              style={{
                fontSize: '1.5em',
                color: Colors.Colors.grey[500].material,
                padding: '0 0 0.5em 0',
                margin: 0
              }}
            >
              {greeting}
            </h1>
          </div>
          <div>
            <TextField
              fullWidth={true}
              hintText={this.context.getIntlMessage('Email')}
              ref="email"
              type="text"
              autoFocus={true}
            />
            <TextField
              onEnterKeyDown={this.submit.bind(this)}
              fullWidth={true}
              hintText={this.context.getIntlMessage('Password')}
              ref="password"
              type="password"
            />
          </div>
          <div
            style={{
              paddingTop: Spacing.desktopGutter * 0.75,
              paddingBottom: Spacing.desktopGutter * 0.25
            }}
          >
            {button}
          </div>
          <p
            style={Object.assign({ cursor: 'pointer' }, h4Style)}
            onTouchTap={() => this.setState({ forgotPassword: true })}
          >
            {this.context.getIntlMessage('forgotPassword')}
          </p>
          {useOtherLogin}
        </form>
        {alternativeLogins}
        {footer}
        <div style={{ textAlign: 'right' }}>
          <a href="mailto:support@coursio.com">
            <IconButton touch tooltip="Contact Support">
              <MaterialIcons.CommunicationEmail
                color={Colors.Colors.grey[500].material}
              />{' '}
            </IconButton>
          </a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/LoginForm.js